document.addEventListener("DOMContentLoaded", () => {
    const editButtons = document.getElementsByClassName("upload-evidence-edit-button");
    Array.prototype.forEach.call(editButtons, (button: HTMLButtonElement) => {
        button.addEventListener("click", () => {
            (button.nextElementSibling as HTMLElement).style.display = 'inline-block';
            (button.nextElementSibling!.nextElementSibling as HTMLElement).style.display = 'inline-block';
            button.style.display = 'none';
            (button.previousElementSibling as HTMLElement).style.display = 'none';
        });
    });

    const cancelButtons = document.getElementsByClassName("upload-evidence-cancel-button");
    Array.prototype.forEach.call(cancelButtons, (button: HTMLButtonElement) => {
        button.addEventListener("click", () => {
            button.style.display = 'none';
            (button.previousElementSibling as HTMLElement).style.display = 'none';
            (button.previousElementSibling!.previousElementSibling as HTMLElement).style.display = 'inline-block';
            (button.previousElementSibling!.previousElementSibling!.previousElementSibling as HTMLElement).style.display = 'inline-block';
        });
    });
});
